import React, { useEffect, useState } from "react";
import { Alert } from "antd";

interface AdminModeBannerProps {
  submitButtonText?: string;
}

const AdminModeBanner: React.FC<AdminModeBannerProps> = ({
  submitButtonText,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      <style jsx global>{`
        .admin-mode-banner .ant-alert {
          padding: 4px 15px !important;
          line-height: 1.5 !important;
        }
        .admin-mode-banner .ant-alert-description {
          margin: 0 !important;
        }
      `}</style>
      <div className="admin-mode-banner">
        <Alert
          className="tc white"
          description={
            submitButtonText
              ? isMobile
                ? `Clicking "${submitButtonText}" will immediately modify the application.`
                : `Admin Mode: Clicking "${submitButtonText}" will immediately modify the application.`
              : isMobile
              ? "Changes made will immediately modify the application."
              : "Admin Mode: Changes made will immediately modify the application."
          }
          banner={true}
          style={{
            backgroundColor: "#E34234",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            margin: 0,
            borderRadius: 0,
            border: "none",
          }}
          showIcon={false}
        />
      </div>
    </>
  );
};

export default AdminModeBanner;
